// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3Z0SU","title":"BackImages_title__1Obfp","images":"BackImages_images__2K2qe"};